import React from "react";
import { Form, Row, Col } from "antd";
import ControlledSelect from "../../components/Backoffice/ControlledSelectV1";
import ControlledInput from "../../components/Backoffice/ControlledInput";

const AddNewSamplerForm = ({
  control,
  errors,
  options,
  isLoadingOperatingDistricts,
}) => {
  const {
    districts = [],
    states = [],
    agencies = [],
    districtsOfMultipleStates = [],
  } = options;

  return (
    <Form colon={false}>
      <Row gutter={24}>
        <Col span={24}>
          <ControlledInput
            required
            control={control}
            name="name"
            label="Name"
            errors={errors}
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={24}>
          <ControlledInput
            required
            control={control}
            name="samplerContact"
            label="Sampler Contact"
            errors={errors}
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={24}>
          <ControlledInput
            required
            control={control}
            name="address"
            label="Address"
            errors={errors}
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={24}>
          <ControlledInput
            required
            control={control}
            name="pincode"
            label="Pincode"
            errors={errors}
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={24}>
          <ControlledInput
            required
            control={control}
            name="email"
            label="Email"
            errors={errors}
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={24}>
          <ControlledSelect
            required
            control={control}
            name="state"
            label="State"
            options={states}
            errors={errors}
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={24}>
          <ControlledSelect
            required
            control={control}
            name="district"
            label="District"
            options={districts}
            errors={errors}
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={24}>
          <ControlledSelect
            required
            control={control}
            name="operatingStates"
            label="Operating States"
            options={states}
            errors={errors}
            multiple={true}
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={24}>
          <ControlledSelect
            required
            control={control}
            name="operatingDistricts"
            label="Operating Districts"
            options={districtsOfMultipleStates}
            errors={errors}
            multiple={true}
            loading={isLoadingOperatingDistricts}
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={24}>
          <ControlledSelect
            required
            control={control}
            name="agency"
            label="Agency"
            options={agencies}
            errors={errors}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default AddNewSamplerForm;
